import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
    ViewEncapsulation
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Design-system dialog/modal card (Figma node 2241:1908203).
 * Renders the Figma "Dialog" chrome — 24px radius, 3-layer drop shadow,
 * 24px padding, H6 title, optional Subtitle-2, 24x24 dismiss X — and projects
 * arbitrary body, an optional leading header icon, and an optional footer.
 *
 * Designed to be the inner content of an NgbModal: styles in
 * `anc-dialog.component.scss` strip NgbModal's legacy .modal-content card
 * so this component owns the visual.
 *
 * @example
 * <lib-anc-dialog [title]="'Track Shipment'" (dismiss)="cancel()">
 *   ...body...
 *   <ng-container dialogFooter>
 *     <button libAncButton variant="tertiary" (click)="cancel()">Cancel</button>
 *     <button libAncButton variant="primary" (click)="save()">Save</button>
 *   </ng-container>
 * </lib-anc-dialog>
 */
@Component({
    selector: 'lib-anc-dialog',
    imports: [CommonModule, TranslateModule],
    templateUrl: './anc-dialog.component.html',
    styleUrls: ['./anc-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None
})
export class AncDialogComponent {
    /** Header Label (H6). Run through the translate pipe. */
    title = input<string>('');
    /** Optional Subtitle-2 line; the row is hidden when empty. */
    subtitle = input<string>('');
    /** Whether to render the 24x24 dismiss X. */
    showClose = input<boolean>(true);

    /** Emitted when the user clicks the dismiss X. */
    readonly dismiss = output<void>();
}
